




















































import Vue from 'vue';
import customerVuex from '../../vuex/common';
import CustomerRemark from '../../models/CustomerRemark';
import commonClient from '../../../common/apis';
import RiskBox from 'common/components/ui/RiskBox/index.vue';
import { TaskType } from '../../../common/models/TaskType';

const newRemarkName: string | null = null;

export default Vue.extend({
  mixins: [customerVuex],
  props: {
    mergeMode: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    RiskBox,
  },
  data() {
    return {
      newRemarkName,
      showConfirmBox: false,
      bodyHeight: 0,
    };
  },
  computed: {
    mergingRemarks(): CustomerRemark[] {
      return this.customerState.mergingRemarks;
    },
    bodyStyles(): any {
      return {
        height: `${this.bodyHeight}px`,
      };
    },
  },
  methods: {
    confirmMerging() {
      commonClient.createTask({
        input: {
          RemarkMerge: {
            ids: this.mergingRemarks.map(r => {
              return r.id;
            }),
            newRemark: this.newRemarkName,
          },
        },
        taskType: TaskType.RemarkMerge,
        expectCount: this.mergingRemarks.map((r: any) => {
          return r.count;
        }).reduce((sum, x) => sum + x),
      }).success(r => {
        this.$Message.success('创建合并标签任务成功，请等待');
        this.$emit('close');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      });
    },
    doShowConfirmBox() {
      if (this.newRemarkName && this.newRemarkName.trim() !== '') {
        this.showConfirmBox = true;
      } else {
        this.$Message.warning('新标签名称不能为空');
      }
    },
    resize() {
      this.bodyHeight = window.innerHeight - 340;
    },
  },
  mounted() {
    this.resize();
    window.onresize = () => {
      this.resize();
    };
  },
});
